import vars from '../helpers';

const scrollTo = (selector, dur, del) => {
	gsap.timeline().to(window, {
		delay: del ? del : 0,
		duration: dur ? dur : vars.duration,
		scrollTo: selector,
		ease: 'Power3.easeOut',
	});
};

const text = (selector, tl, dur, del) => {
	let tlAnim = tl ? tl : gsap.timeline();

	tlAnim.from(selector, {
		delay: del ? del : 0,
		duration: dur ? dur : vars.duration,
		text: '',
		ease: 'none',
	}, '-=10%').from(selector, {
		duration: dur ? dur : vars.duration,
		x: 30,
		ease: 'Circ.easeOut',
		clearProps: 'all',
	}, '<');
};

const fade = (selector, tl, dur, del, begin) => {
	let tlAnim = tl ? tl : gsap.timeline();

	tlAnim.to(selector, {
		delay: del ? del : 0,
		duration: dur ? dur : vars.duration,
		opacity: 1,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	}, begin ? begin : '>');
};

const fadeUp = (selector, tl, dur, del, begin) => {
	let tlAnim = tl ? tl : gsap.timeline();

	tlAnim.from(selector, {
		delay: del ? del : 0,
		duration: dur ? dur : vars.duration,
		opacity: 0,
		y: 30,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	}, begin ? begin : '>');
};

const fadeDown = (selector, tl, dur, del, begin) => {
	let tlAnim = tl ? tl : gsap.timeline();

	tlAnim.from(selector, {
		delay: del ? del : 0,
		duration: dur ? dur : vars.duration,
		opacity: 0,
		y: '-100%',
		ease: 'Power1.easeOut',
		clearProps: 'all',
	}, begin ? begin : '>');
};

const fadeLeft = (selector, tl, dur, del, begin) => {
	let tlAnim = tl ? tl : gsap.timeline();

	tlAnim.from(selector, {
		delay: del ? del : 0,
		duration: dur ? dur : vars.duration,
		opacity: 0,
		x: 30,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	}, begin ? begin : '>');
};

export default {
	scrollTo,
	text,
	fade,
	fadeUp,
	fadeDown,
	fadeLeft,
};
